import * as Type from './actionsTypes';

const saveFolhaPonto  = data => ({ type: Type.FOLHA_PONTO_SAVE, data });

const updateFolhaPonto = (id, data) => ({ type: Type.FOLHA_PONTO_UPDATE, id, data });

const findFolhaPontoById = id => ({ type: Type.FOLHA_PONTO_FIND_ONE, id });

const folhaPontoClearSelected = () => ({ type: Type.FOLHA_PONTO_CLEAR_SELECTED });

const folhaPontoUpdateStatus = (data, callback) => ({ type: Type.FOLHA_PONTO_UPDATE_STATUS, data, callback });

const folhaPontoReport = (filtro, callback) => ({ type: Type.FOLHA_PONTO_REPORT, filtro, callback });

const downloadFolhaPontoById = (folhaPontoId, tipoFolhaPonto) => ({ type: Type.FOLHA_PONTO_DOWNLOAD, folhaPontoId, tipoFolhaPonto });

const uploadFilledFolhaPonto = (folhaPontoId, arquivo, callback) => ({ type: Type.FOLHA_PONTO_UPLOAD_FILLED, folhaPontoId, arquivo, callback });

const deleteFolhaPonto = (id, callback) => ({ type: Type.FOLHA_PONTO_DELETE, id, callback });

export {
  saveFolhaPonto,
  updateFolhaPonto,
  findFolhaPontoById,
  folhaPontoClearSelected,
  folhaPontoUpdateStatus,
  folhaPontoReport,
  downloadFolhaPontoById,
  uploadFilledFolhaPonto,
  deleteFolhaPonto
}
